
<div class="container pt-2">
    <table>
        <thead>
          <tr>
            <th appResizableColumns>Column 1</th>
            <th appResizableColumns>Column 2</th>
            <th appResizableColumns>Column 3</th>
            <!-- Add more columns as needed -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Data 1 vijay kumar</td>
            <td>Data 2 nagaraju</td>
            <td>Data 3 vinay kumar</td>
            <!-- Add more cells as needed -->
          </tr>
          <!-- Add more rows as needed -->
        </tbody>
      </table>
</div>